// src/application/hooks/useMerchantDetails.js
import { useEffect } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { getMerchantDetails } from "../actions/merchantActions";

export const useMerchantDetails = (merchantId) => {
  const dispatch = useDispatch();  
  
  const {
    merchant_details,
    isLoading,
    requestStatus,
  } = useSelector(
    (state) => ({
      merchant_details: state.merchants.details || {},
      isLoading: state.app.loading || [],
      requestStatus: state.app.requestStatus || [],
    }),
    shallowEqual
  );

  useEffect(() => {
    // Fetch hanya jika merchantId berubah
    if (merchantId) {
      dispatch(getMerchantDetails(merchantId));
    }
  }, [merchantId, dispatch]);

  return {
    data: merchant_details,
    isLoading,
    error: requestStatus,
  };
};